module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/1351cfebee3d46c2f9d01e50658a08bd.svg";